<template>
  <div class="container">
    <pcTabBarComponent />
    <div class="public-content" v-if="goodsInfo && goodsInfo.Id">
      <div class="goods-detail-container">
        <div class="img-item img-cover">
          <img v-if="goodsInfo.GoodsThumb" :src="goodsInfo.GoodsThumb" />
          <img v-else src="../../assets/images/no-image-icon.png" />
        </div>
        <div class="goods-info-item">
          <div class="name-item"><span v-if="goodsInfo.Lable">{{ goodsInfo.Lable }}</span>{{ goodsInfo.GoodsName }}</div>
          <div class="detail-item">
            <div class="collect-btn" :class="goodsInfo.IsCollect > 0 ? 'active' : ''" @click="handleCollection">
              <img v-if="goodsInfo.IsCollect > 0" src="../../assets/pc-images/star-active-icon.png" />
              <img v-else src="../../assets/pc-images/star-icon.png" />
              收藏
            </div>
            <div class="item">
              <div class="name">商品价格: </div>
              <div class="money">¥ <span>{{ goodsInfo.GoodsPrice }}</span></div>
            </div>
            <div class="item">
              <div class="name">商品库存: </div>
              <div class="value">{{ goodsInfo.GoodsStock == -1 ? 999999 : goodsInfo.GoodsStock }}</div>
            </div>
            <div class="item">
              <div class="name">商品服务: </div>
              <div class="nav-list">
                <div class="nav"><img class="icon" src="../../assets/pc-images/footer-nav-1-icon.png" />行业领先</div>
                <div class="nav"><img class="icon" src="../../assets/pc-images/footer-nav-2-icon.png" />价格实惠</div>
                <div class="nav"><img class="icon" src="../../assets/pc-images/footer-nav-3-icon.png" />官方流量</div>
                <div class="nav"><img class="icon" src="../../assets/pc-images/footer-nav-4-icon.png" />7X24小时</div>
              </div>
            </div>
          </div>
          <div class="params-list-item">
            <div class="params-item">
              <div class="name">下单数量：</div>
              <div class="order-count">
                <div class="input-number">
                  <el-input-number v-model="count" :step="goodsInfo.BuyRate" :min="goodsInfo.BuyMinLimit != -1 ? goodsInfo.BuyMinLimit : goodsInfo.BuyRate" :max="goodsInfo.BuyMaxLimit != -1 ? goodsInfo.BuyMaxLimit : Infinity" />
                </div>
                <div class="count-tip">下单数量范围 ({{ goodsInfo.BuyMinLimit == -1 ? '不限' : goodsInfo.BuyMinLimit }} - {{ goodsInfo.BuyMaxLimit == -1 ? '不限' : goodsInfo.BuyMaxLimit }})</div>
              </div>
            </div>
            <div class="params-item" v-for="(item, index) in goodsInfo.ParamsTemplate" :key="index">
              <div class="name"><span>*</span>{{ item.name }}：</div>
              <div v-if="item.type == 2" class="textarea"><textarea v-model="item.value" :placeholder="item.description" rows="2"></textarea></div>
              <div v-else-if="item.type == 4" class="input"><input v-model="item.value" :placeholder="item.description" type="password" /></div>
              <div v-else-if="item.type == 3 || item.type == 5 || item.type == 8" class="picker">
                <el-select v-model="item.value" :placeholder="item.description" style="width: 100%;">
                  <el-option v-for="(item, index) in item.type_config" :key="index" :label="item" :value="item" />
                </el-select>
              </div>
              <div v-else-if="item.type == 6" class="input"><input v-model="item.value" :placeholder="item.description" type="number" @blur="handleVerifyInput(item, index)" /></div>
              <div v-else-if="item.type == 7" class="input-number"><el-input-number v-model="item.value" :step="item.verify.bs" :min="item.verify.bs || 1" /></div>
              <div v-else-if="item.type == 9" class="upload-img">
                <van-uploader :name="index" :preview-image="false" :deletable="false" :after-read="handleUploadImg">
                  <div v-if="item.value" class="img img-cover"><img :src="item.value" /></div>
                  <div v-else class="add-img img-contain"><img src="../../assets/images/add-icon.png" /></div>
                </van-uploader>
              </div>
              <template v-else-if="item.type == 63">
                <div v-if="item.value && item.isInput" class="input"><input v-model="item.content" readonly @click="item.isInput = false" /></div>
                <div v-else class="input"><input v-model="item.qq" placeholder="QQ号码" type="text" @blur="handleVerifyInput(item, index)" /></div>
              </template>
              <div v-else class="input"><input v-model="item.value" :placeholder="item.description" type="text" @blur="handleVerifyInput(item, index)" /></div>
            </div>
            <!-- <div class="params-item">
              <div class="name">执行方式：</div>
              <div class="zx-type">
                <div class="type" :class="zxType == 1 ? 'active' : ''" @click="zxType = 1">立即执行</div>
                <div v-if="goodsInfo.GoodsType == 1 && zxOrder.dszx == 1" class="type" :class="zxType == 2 ? 'active' : ''" @click="zxType = 2">定时执行</div>
                <div v-if="goodsInfo.GoodsType == 1 && zxOrder.jshzx == 1" class="type" :class="zxType == 3 ? 'active' : ''" @click="zxType = 3">结束后执行</div>
                <div v-if="goodsInfo.GoodsType == 1 && zxOrder.dayzx == 1" class="type" :class="zxType == 4 ? 'active' : ''" @click="zxType = 4">每天执行</div>
              </div>
            </div> -->
            <div v-if="zxType > 1" class="params-item">
              <div class="name"></div>
              <div v-if="zxType == 2" class="zx-detail-2">
                <el-date-picker v-model="dszxExpTime" type="datetime" placeholder="选择日期时间"></el-date-picker>
              </div>
              <div v-if="zxType == 3" class="zx-detail-3">
                <div class="orderno">
                  <input v-model="zxOrderNo" type="text" placeholder="填写之前执行的订单号" />
                </div>
                延后
                <div class="time">
                  <input v-model="exeTime" type="number" />
                </div>
                分钟后执行
              </div>
              <div v-if="zxType == 4" class="zx-detail-4">
                共
                <div class="day">
                  <input v-model="mtzxDay" type="number" min="1" />
                </div>
                天
                &nbsp;&nbsp;
                每天
                <div class="time">
                  <el-time-picker v-model="mtzxExpTime" format="HH:mm" placeholder="选择时间" style="width: 100%;"></el-time-picker>
                </div>
              </div>
            </div>
          </div>
          <div class="total-money">
            <div class="name">合计: </div>
            <div class="money">¥ <span>{{ money }}</span></div>
          </div>
          <div class="buy-btn-item" :class="goodsInfo.IsClose == 2 ? '' : 'not'" @click="handleSubmit">
            <van-loading v-if="submiting" size="20" color="#ffffff" />
            <div v-else class="btn">
              <img src="../../assets/pc-images/cart-icon.png" class="icon" />
              {{ goodsInfo.IsClose == 2 ? '立即购买' : '暂停购买' }}
            </div>
          </div>
        </div>
      </div>
      <div class="goods-detail-item">
        <div class="page-title-item">
          <div class="title">商品详情</div>
          <div class="czzy" @click="showCzzyPopup = true"><img src="../../assets/pc-images/info-icon.png" class="icon" />操作指引</div>
        </div>
        <div class="detail-item">
          <div v-html="goodsInfo.GoodsDetail"></div>
        </div>
      </div>
    </div>
    <van-dialog title="操作指引" v-model="showCzzyPopup" :show-cancel-button="false" confirm-button-text="关闭" type="danger" class-name="pc-dialog pc-gg-dialog">
      <div class="van-dialog__message czzy-list-item">
        <div class="czzy-item" v-for="(item, index) in goodsInfo.Czzy" :key="index" @click="handleShowCzzy(item)">
          <div class="name">{{ index + 1 }}、{{ item.name }}</div>
          <div class="icon img-cover"><img src="../../assets/images/right-blue-1-icon.png" /></div>
        </div>
      </div>
    </van-dialog>
    <pcSubmitOrder ref="pcSubmitOrderDialog" />
  </div>
</template>

<script>
import pcTabBarComponent from '../../components/pcTabBarComponent.vue'
import pcSubmitOrder from '@/components/pcSubmitOrder.vue'
import { mapState } from 'vuex'

export default {
  name: "GoodsDetail",
  components: {
    pcTabBarComponent,
    pcSubmitOrder
  },
  data() {
    return {
      id: '',
      goodsInfo: {
        ParamsTemplate: []
      },
      submiting: false,
      orderType: 1,
      zxOrder: {
        dszx: 1,
        jshzx: 1,
        dayzx: 1
      },
      zxType: 1,
      dszxExpTime: '',
      dszxMinTime: '',
      zxOrderNo: '',
      exeTime: '',
      mtzxDay: 1,
      mtzxExpTime: '',
      count: 0,
      money: 0,
      showCzzyPopup: false
    }
  },
  computed: {
    ...mapState(['userInfo', 'websiteInfo'])
  },
  watch: {
    'goodsInfo.ParamsTemplate': {
      handler: function () {
        this.calcMoney()
      },
      deep: true
    },
    count() {
      this.calcMoney()
    },
    countType3Count(value) {
      const { plData } = this
      for (let i = 0; i < plData.length; i++) {
        const item = plData[i]
        if (item.value) {
          this.plData[i].count = value
        }
      }
      this.calcMoney()
    },
    mtzxDay() {
      this.calcMoney()
    },
  },
  mounted() {
    this.handleGetSet()
    if (this.$route.query && this.$route.query.id) {
      this.id = this.$route.query.id
      this.handleGetGoodsDetail()
    }
  },
  methods: {
    async handleGetSet() {
      var res = await this.$API.getSet.post({
        Key: 'zx_order'
      })
      if (res.info) {
        const data = JSON.parse(res.info)
        this.zxOrder = data
      }
    },
    async handleGetGoodsDetail() {
      const { userInfo } = this
      if (userInfo && userInfo.Id && userInfo.UserIsGoods != 1) {
        return
      }
      const { id, websiteInfo } = this
      var res = await this.$API.goodsDetail.post({
        Id: id,
        AdminId: websiteInfo.Id
      })
      if (res.error == 0) {
        try {
          res.info.ParamsTemplate = JSON.parse(res.info.ParamsTemplate)
        } catch (error) {
          res.info.ParamsTemplate = []
        }
        try {
          res.info.Czzy = JSON.parse(res.info.Czzy)
        } catch (error) {
          res.info.Czzy = []
        }

        const plTipArr = []
        if (res.info.ParamsTemplate) {
          for (let i = 0; i < res.info.ParamsTemplate.length; i++) {
            const item = res.info.ParamsTemplate[i]
            if (item.type == 3 || item.type == 5 || item.type == 8) {
              res.info.ParamsTemplate[i].type_config = item.type_config.split(',')
            }
            plTipArr.push(item.name)
          }
        } else {
          res.info.ParamsTemplate = []
        }
        plTipArr.push('数量')
        this.plTip = plTipArr.join('----')
        res.info.BuyRate = res.info.BuyRate || 1
        this.count = res.info.BuyMinLimit > res.info.BuyRate ? res.info.BuyMinLimit : res.info.BuyRate
        this.goodsInfo = res.info
        if (res.info.IsTc == 1) {
          this.$dialog.alert({
            type: 'danger',
            className: 'pc-dialog pc-gg-dialog',
            title: res.info.TcTitle,
            message: res.info.TcContent,
            confirmButtonText: '确定',
          })
        }
        this.calcMoney()
      }
    },
    calcMoney() {
      const { goodsInfo, orderType, zxType, mtzxDay } = this
      if (orderType == 1) {
        const { count } = this
        if (!count) {
          this.money = 0
          return
        }
        let number = parseInt(count)
        const { ParamsTemplate } = goodsInfo
        if (ParamsTemplate && ParamsTemplate.length > 0) {
          for (let i = 0; i < ParamsTemplate.length; i++) {
            const item = ParamsTemplate[i]
            if (item.type == 7 || item.type == 8) {
              if (item.value) {
                number = number * parseInt(item.value)
              } else {
                this.money = 0
                return
              }
            }
          }
        }
        let money = parseFloat(goodsInfo.GoodsPrice) * number
        if (zxType == 4) {
          money = money * parseInt(mtzxDay)
        }
        money = isNaN(money) ? 0 : money
        this.money = Math.round(money * 10000000) / 10000000
      }
      if (orderType == 2) {
        const { plData } = this
        let number = 0
        for (let i = 0; i < plData.length; i++) {
          const pl = plData[i]
          if (pl.value) {
            let plNumber = parseInt(pl.count)
            const value = pl.value.split('----')
            const { ParamsTemplate } = goodsInfo
            if (ParamsTemplate && ParamsTemplate.length > 0) {
              for (let j = 0; j < ParamsTemplate.length; j++) {
                const item = ParamsTemplate[j]
                if (item.type == 7 || item.type == 8) {
                  plNumber = plNumber * parseInt(value[j])
                }
              }
            }
            number = number + plNumber
          }
        }
        this.money = parseFloat(goodsInfo.GoodsPrice) * number
      }
    },
    async handleVerifyInput(item, index) {
      let value = item.value.trim()
      this.$set(this.goodsInfo.ParamsTemplate[index], 'value', value)
      if (item.type == 6 && !this.$TOOL.numberRegex(value)) {
        this.$toast(item.name + '格式不正确')
        this.$set(this.goodsInfo.ParamsTemplate[index], 'value', '')
        return
      }
      if (item.type == 21 && !this.$TOOL.qqRegex(value)) {
        this.$toast(item.name + '格式不正确')
        this.$set(this.goodsInfo.ParamsTemplate[index], 'value', '')
        return
      }
      if (item.type == 22 && !this.$TOOL.phoneRegex(value)) {
        this.$toast(item.name + '格式不正确')
        this.$set(this.goodsInfo.ParamsTemplate[index], 'value', '')
        return
      }
      if (item.type == 23 && !this.$TOOL.emailRegex(value)) {
        this.$toast(item.name + '格式不正确')
        this.$set(this.goodsInfo.ParamsTemplate[index], 'value', '')
        return
      }
      if (item.type == 61 && value) {
        let res = await this.handleGetDouYinMasterUrl(value)
        if (res.error == 0 && res.info) {
          this.$set(this.goodsInfo.ParamsTemplate[index], 'value', res.info)
        } else {
          this.$toast(item.name + '格式不正确')
          this.$set(this.goodsInfo.ParamsTemplate[index], 'value', '')
        }
        return
      }
      if (item.type == 62 && value) {
        let res = await this.handleGetdouyinkuaishouid(value)
        if (res.error == 0 && res.info) {
          this.$set(this.goodsInfo.ParamsTemplate[index], 'value', res.info)
        } else {
          this.$toast(item.name + '格式不正确')
          this.$set(this.goodsInfo.ParamsTemplate[index], 'value', '')
        }
        return
      }
      if (item.type == 63 && item.qq) {
        const loading = this.$loading({
          background: 'rgba(0,0,0,.3)'
        })
        let res = await this.handleGetSS(item.qq, 1)
        loading.close()
        res = JSON.parse(res)
        if (res.code == 0) {
          this.qqSsPopup = {
            show: true,
            index: index,
            qq: item.qq,
            page: 1,
            finish: res.data.length == 0,
            loading: false,
            dataList: res.data
          }
        } else {
          this.$toast(res.msg)
        }
        return
      }
      
    },
    async handleGetQqSsDataList() {
      const { qqSsPopup } = this
      const page = qqSsPopup.page + 1
      let res = await this.handleGetSS(qqSsPopup.qq, page)
      res = JSON.parse(res)
      if (res.code == 0) {
        this.qqSsPopup.dataList = [
          ...qqSsPopup.dataList,
          ...res.data
        ]
        this.qqSsPopup.page = page
        this.qqSsPopup.finish = !res.data || res.data == 0
        this.qqSsPopup.loading = false
      } else {
        this.$toast(res.msg)
      }
    },
    handleSetQqData(index) {
      const { qqSsPopup, orderType } = this
      if (orderType == 1) {
        this.$set(this.goodsInfo.ParamsTemplate[qqSsPopup.index], 'value', qqSsPopup.dataList[index].tid)
        this.$set(this.goodsInfo.ParamsTemplate[qqSsPopup.index], 'content', qqSsPopup.dataList[index].content)
        this.$set(this.goodsInfo.ParamsTemplate[qqSsPopup.index], 'isInput', true)
      }
      this.qqSsPopup.show = false
    },
    handleHideQqShPopup() {
      const { qqSsPopup, orderType } = this
      if (orderType == 1) {
        if (this.goodsInfo.ParamsTemplate[qqSsPopup.index].value) {
          this.$set(this.goodsInfo.ParamsTemplate[qqSsPopup.index], 'isInput', true)
        }
      }
    },
    async handleUploadImg(file, detail) {
      var res = await this.$API.upload.post(file[0])
      if (res.error == 0) {
        const index = detail.name
        this.goodsInfo.ParamsTemplate[index].value = this.formatImgPath(res.info)
      } else {
        this.$dialog.alert({
          type: 'danger',
          className: 'pc-dialog',
          title: '提示',
          message: res.info,
          confirmButtonText: '确定',
        })
      }
    },
    formatImgPath(path) {
      if (/^(?:[a-z]+:)?\/\//i.test(path)) {
        return path
      }
      let pre = process.env.NODE_ENV === 'development' ? process.env.VUE_APP_API_BASEURL : window.location.origin
      if (pre.endsWith('/')) {
        pre = pre.slice(0, -1)
      }
      return pre + path
    },
    async handleGetDouYinMasterUrl(data) {
      var res = this.$API.getDouYinMasterUrl.post({
        Url: data
      })
      return res
    },
    async handleGetdouyinkuaishouid(data) {
      var res = this.$API.getdouyinkuaishouid.post({
        Url: data
      })
      return res
    },
    async handleGetSS(qq, page) {
      var res = await this.$API.getSS.post({
        Qq: qq,
        Page: page
      })
      return res
    },
    async handleCollection() {
      const { goodsInfo } = this
      var res = await this.$API.addGoodsCollect.post({
        GoodsId: goodsInfo.Id
      })
      if (res.error == 0) {
        this.goodsInfo.IsCollect = goodsInfo.IsCollect > 0 ? 0 : 1
      } else {
        this.$dialog.alert({
          type: 'danger',
          className: 'pc-dialog',
          title: '提示',
          message: res.info,
          confirmButtonText: '确定',
        })
      }
      return false
    },
    async handleSubmit() {
      const { submiting, goodsInfo, zxType, count, dszxExpTime, zxOrderNo, exeTime, mtzxDay, mtzxExpTime } = this
      if (goodsInfo.IsClose == 1) {
        return
      }
      if (submiting) {
        return
      }
      this.submiting = true
      setTimeout(() => {
        const orderParams = []
        for (let i = 0; i < goodsInfo.ParamsTemplate.length; i++) {
          const item = goodsInfo.ParamsTemplate[i]
          let value = item.value
          if (!item.value) {
            this.$toast(item.name + '不能为空')
            this.submiting = false
            return
          }
          orderParams.push({
            name: item.name,
            alias: item.key,
            value: value
          })
        }
        const params = {
          GoodsIds: goodsInfo.Id,
          ZxType: zxType,
          OrderNum: count,
          OrderParams: JSON.stringify([orderParams])
        }
        if (zxType == 1) {
          params.ExpTime = this.$TOOL.dateFormat(new Date())
        }
        if (zxType == 2) {
          if (!dszxExpTime) {
            this.$toast('请选择执行时间')
            this.submiting = false
            return
          }
          params.ExpTime = this.$TOOL.dateFormat(dszxExpTime)
        }
        if (zxType == 3) {
          if (!zxOrderNo) {
            this.$toast('请输入之前执行的订单号')
            this.submiting = false
            return
          }
          if (exeTime === '') {
            this.$toast('请输入延时执行时间')
            this.submiting = false
            return
          }
          params.ExeTime = exeTime
          params.ZxOrderNo = zxOrderNo
        }
        if (zxType == 4) {
          if (!mtzxDay) {
            this.$toast('请输入执行天数')
            this.submiting = false
            return
          }
          if (!mtzxExpTime) {
            this.$toast('请选择执行时间')
            this.submiting = false
            return
          }
          const max = parseInt(mtzxDay)
          for (let i = 0; i < max; i++) {
            if (i == 0) {
              params.ExpTime = this.$TOOL.dateFormat(new Date(), 'yyyy-MM-dd') + ' ' + mtzxExpTime
              params.OrderParams = [orderParams]
            } else {
              params.GoodsIds += ',' + goodsInfo.Id
              params.OrderNum += ',' + count
              params.ExpTime += ',' + this.$TOOL.dateFormat((new Date().getTime()) + (i * 24 * 3600 * 1000), 'yyyy-MM-dd') + ' ' + mtzxExpTime
              params.OrderParams.push(orderParams)
            }
          }
          params.OrderParams = JSON.stringify(params.OrderParams)
        }
        this.submiting = false
        this.$refs.pcSubmitOrderDialog.open({
          params,
          money: this.money
        })
      }, 500);
    },
    handleShowCzzy(item) {
      this.$dialog.alert({
        type: 'danger',
        className: 'pc-dialog pc-gg-dialog',
        title: item.name,
        message: item.content,
        confirmButtonText: '关闭',
      })
    }
  }
}
</script>

<style lang="less" scoped>
.goods-detail-container {
  margin-top: 20px;
  background-color: #fff;
  border-radius: 5px;
  padding: 20px 20px 45px;
  display: flex;
  justify-content: space-between;
  .img-item {
    width: 340px;
    height: 340px;
    border-radius: 5px;
    overflow: hidden;
    margin-right: 24px;
  }
  .goods-info-item {
    flex: 1;
    .name-item {
      line-height: 28px;
      color: #393942;
      font-size: 18px;
      font-weight: 500;
      span {
        height: 20px;
        line-height: 20px;
        padding: 0 2px;
        margin-right: 2px;
        margin-top: 4px;
        font-size: 12px;
        color: #fff;
        border-radius: 2px;
        background: linear-gradient( 315deg, #ffaa8a 0%, #ffde58 100%);
      }
    }
    .detail-item {
      position: relative;
      background-color: #f7f7f7;
      border-radius: 5px;
      padding: 15px;
      margin-top: 20px;
      .collect-btn {
        position: absolute;
        right: 0;
        top: 0;
        width: 90px;
        height: 25px;
        border: 1px solid #ff8400;
        border-radius: 0 5px 0 5px;
        color: #ff8400;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        &.active {
          background-color: #ff8400;
          color: #fff;
        }
        img {
          width: 16px;
          height: 16px;
          margin-right: 5px;
        }
      }
      .item {
        display: flex;
        margin-bottom: 10px;
        font-size: 12px;
        .name {
          width: 60px;
          color: #64748b;
        }
        .money {
          flex: 1;
          font-size: 10px;
          color: #d43030;
          span {
            font-size: 12px;
          }
        }
        .value {
          flex: 1;
          color: #64748b;
        }
        .nav-list {
          flex: 1;
          display: flex;
          align-items: center;
          .nav {
            display: flex;
            align-items: center;
            font-size: 12px;
            color: #a1a8b4;
            margin-right: 30px;
            &:nth-last-child(1) {
              margin-right: 0;
            }
            .icon {
              width: 16px;
              height: 16px;
              margin-right: 10px;
            }
          }
        }
      }
    }
  }
  .params-list-item {
    margin-top: 20px;
    .params-item {
      display: flex;
      margin-bottom: 15px;
      font-size: 12px;
      input, textarea {
        font-size: 12px;
      }
      .name {
        width: 68px;
        padding: 5px 0;
        line-height: 15px;
        color: #64748b;
        span {
          color: #d43030;
        }
      }
      .order-count {
        display: flex;
        align-items: center;
        .count-tip {
          color: #a1a8b4;
          margin-left: 8px;
        }
      }
      .input {
        width: 290px;
        height: 25px;
        background-color: #f7f7f7;
        border-radius: 2px;
        padding: 0 10px;
      }
      .textarea {
        width: 290px;
        background-color: #f7f7f7;
        border-radius: 2px;
        padding: 5px 10px;
        line-height: 15px;
      }
      .picker {
        width: 310px;
        height: 25px;
        background-color: #f7f7f7;
        border-radius: 2px;
      }
      .input-number {
        /deep/.el-input-number {
          width: 125px;
          line-height: 25px;
          .el-input-number__decrease,
          .el-input-number__increase {
            width: 20px;
          }
          .el-input__inner {
            height: 27px;
            line-height: 25px;
            padding: 0 30px;
          }
        }
      }
      /deep/.el-select {
        .el-input__inner {
          height: 25px;
          line-height: 25px;
          background: none;
          border: none;
        }
        .el-input__icon {
          line-height: 25px;
        }
      }
      .upload-img {
        .img, .add-img {
          width: 60px;
          height: 60px;
          border: 1px solid #eff2f8;
          border-radius: 2px;
          overflow: hidden;
        }
        .add-img {
          box-sizing: border-box;
          padding: 20px;
        }
        /deep/.van-uploader__wrapper {
          margin: 0;
        }
      }
      .zx-type {
        display: flex;
        align-items: center;
        .type {
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #f7f7f7;
          border-radius: 2px;
          margin-right: 10px;
          padding: 0 4px;
          height: 25px;
          color: #64748b;
          &.active {
            color: #fff;
            background-color: #5783fc;
          }
        }
      }
      .zx-detail-2 {
        /deep/.el-input__inner {
          height: 25px;
          line-height: 25px;
          font-size: 12px;
        }
        /deep/.el-input__icon {
          line-height: 27px;
        }
      }
      .zx-detail-3 {
        display: flex;
        align-items: center;
        .orderno {
          width: 120px;
          height: 25px;
          background-color: #f7f7f7;
          border-radius: 2px;
        }
        .time {
          width: 40px;
          height: 25px;
          background-color: #f7f7f7;
          border-radius: 2px;
        }
      }
      .zx-detail-4 {
        display: flex;
        align-items: center;
        .day {
          width: 30px;
          height: 25px;
          background-color: #f7f7f7;
          border-radius: 2px;
          input {
            text-align: center;
          }
        }
        .time {
          width: 120px;
          /deep/.el-input__inner {
            height: 25px;
            line-height: 25px;
            font-size: 12px;
          }
          /deep/.el-input__icon {
            line-height: 27px;
          }
        }
      }
    }
  }
  .total-money {
    margin-bottom: 15px;
    color: #64748b;
    display: flex;
    align-items: center;
    .name {
      width: 68px;
    }
    .money {
      color: #d43030;
      span {
        font-size: 20px;
      }
    }
  }
  .buy-btn-item {
    width: 90px;
    height: 25px;
    border-radius: 2px;
    background-color: #fa0c11;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    &.not {
      background-color: rgba(250, 12, 17, .5);
    }
    .btn {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-size: 12px;
      .icon {
        width: 16px;
        height: 16px;
        margin-right: 5px;
      }
    }
  }
}
.goods-detail-item {
  margin-top: 20px;
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
  margin-bottom: 100px;
  .page-title-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 28px;
    .title {
      line-height: 28px;
      font-size: 18px;
      font-weight: 500;
      color: #393942;
      position: relative;
      padding-left: 18px;
      &::before {
        content: '';
        position: absolute;
        top: 4px;
        left: 0;
        width: 3px;
        height: 20px;
        background-color: #5783fc;
        border-radius: 0 2px 2px 0;
      }
    }
    .czzy {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      font-size: 12px;
      color: #64748b;
      .icon {
         width: 16px;
         height: 16px;
         margin-right: 5px;
      }
    }
  }
  .detail-item {
    margin-top: 20px;
    padding: 20px;
    background-color: #f7f7f7;
    border-radius: 5px;
    font-size: 12px;
    line-height: 20px;
    /deep/img {
      max-width: 100%;
      height: auto;
    }
  }
}
.czzy-list-item {
  .czzy-item {
    height: 25px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    cursor: pointer;
    .name {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #5783fc;
      font-size: 12px;
    }
    .icon {
      width: 16px;
      height: 16px;
      margin-left: 10px;
    }
  }
}
</style>